import { buildInvoiceFileName } from "@msys/common";
import { GetApp as DownloadIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { useOpenAttachment } from "../attachments/useOpenAttachment.js";

export function IncomingInvoiceDownloadButton({
  projectId,
  invoiceId,
  invoiceNumber,
}: {
  projectId: string;
  invoiceId: string;
  invoiceNumber: string | null;
}) {
  const { t } = useTranslate("Invoices");
  const { openAttachment } = useOpenAttachment();

  return (
    <Tooltip title={t("Download PDF", { ns: "Invoices" })}>
      <IconButton
        size="small"
        color="primary"
        onClick={e => {
          e.stopPropagation();
          openAttachment(
            { kind: "incoming_invoice_pdf", projectId, ownerId: invoiceId },
            buildInvoiceFileName({
              number: invoiceNumber,
              id: invoiceId,
              kind: "pdf",
            }),
            { as: "pdf", filenameFromResponse: true }
          );
        }}
      >
        <DownloadIcon />
      </IconButton>
    </Tooltip>
  );
}
